export const TOOLTIPS = {
  whitespace: {
    label: 'Whitespace',
    definition: 'Any opportunity to sell a Gatekeeper solution that is not currently installed at a store.',
  },
  gkap: {
    label: 'GKAP',
    definition: 'Share of serviceable stores acquired in a neighbourhood for a channel.',
  },
  acquiredSite: {
    label: 'Acquired Site',
    definition: 'A retail location with at least one Gatekeeper solution installed.',
  },
  serviceableSites: {
    label: 'Serviceable Sites',
    definition: 'All operational retail locations eligible for Gatekeeper solutions.',
  },
  crimeIndex: {
    label: 'Crime Index',
    definition: 'A score that indicates the risk level of crime (Low–Critical) in a specific store\'s geographic area using FBI Uniform Crime Reporting (UCR) data.',
  },
  penetration: {
    label: 'Penetration %',
    definition: 'Percentage of acquired sites within a defined geography, brand, or region',
  },
  crimeData: {
    label: 'Crime/Year',
    definition: 'The average number of relevant crime incidents reported via UCR in a geographic area on an annual basis. For now, the included crimes involve Larceny, Burglary Breaking & Entering, Credit Card Automated Teller Machine Fraud, Drug Equipment Violations, Drug Narcotic Violations, Purse-snatching, Robbery, Shoplifting, Stolen Property Offenses, Theft From Building and Theft From Coin-Operated Machine or Device.',
  },
  cartPenalty: {
    label: 'Cart Ordinance',
    definition: 'Indicates whether local laws penalize retailers for shopping cart abandonment.',
  },
  estimatedRevenue: {
    label: 'Estimated Revenue Addition',
    definition: 'Projected incremental revenue from deploying Gatekeeper solutions in whitespace opportunities',
  },
  installedSolutions: {
    label: 'Installed Solutions',
    definition: 'Gatekeeper solutions that have already been installed and deployed at a retail location.',
  },
  recommendedSolutions: {
    label: 'Recommended Solutions',
    definition: 'Solutions suggested for a store based on readiness score and configuration rules.',
  },
  neighborhoodSites: {
    label: 'Neighbourhood Sites',
    definition: 'Number of retail locations within a five-mile radius of a reference store.',
  },
  penetrationPercentage: {
    label: 'Penetration Percentage',
    definition: 'The percentage of stores in the region that have adopted the solution out of total serviceable sites.',
  },
  estimatedCarts: {
    label: 'Estimated Carts',
    definition: 'The estimated average number of shopping carts per store.',
  },
  hotDays: {
    label: 'Hot Days',
    definition: 'The number of days in a calendar year with temperature reaching 90°F.',
  },
  coldDays: {
    label: 'Cold Days',
    definition: 'The number of days in a calendar year with temperature reaching 32°F.',
  },
  partOfPlaza: {
    label: 'Part of a Shopping Complex',
    definition: 'Whether the store location is part of a shopping complex. This is relevant especially when there is a customer containment store in the same complex.',
  },
  ordinance: {
    label: 'Ordinance',
    definition: 'Local regulatory requirements or penalties associated with cart liability and compliance.',
  },
  singleWheelReplacement: {
    label: 'Single Wheel Replacement',
    definition: 'Tthe percentage of single wheels that had to be replaced because they were (likely) broken due to increased pushouts or rough handling.',
  },
  serviceFrequency: {
    label: 'Service Frequency',
    definition: 'The number of service visits after a new install.',
  },
};

export const getTooltip = (key: keyof typeof TOOLTIPS) => {
  return TOOLTIPS[key];
};

export const getTooltipText = (key: keyof typeof TOOLTIPS): string => {
  return TOOLTIPS[key]?.definition || '';
};

export const getTooltipLabel = (key: keyof typeof TOOLTIPS): string => {
  return TOOLTIPS[key]?.label || '';
};
